export default {
  INLINE: 'inline',
  BACKGROUND: 'background',
};
